import { CodeHighlight } from '@mantine/code-highlight';
import { IconDatabaseCog } from '@tabler/icons-react';
import classes from './DemoCode.module.css';

export interface DemoCodeProps {
    // code?: string | CodeHighlightTabsCode[];
    code?: string;
    defaultExpanded?: boolean;
    maxCollapsedHeight?: number;
}

export function DemoCode({ code, maxCollapsedHeight, defaultExpanded }: DemoCodeProps) {
    // const _code: CodeHighlightTabsCode | CodeHighlightTabsCode[] | undefined =
    //     typeof code === 'string' ? [{ code, fileName: 'Options', language: 'yaml' }] : code;
    return code ? (
        <CodeHighlight
            code={code}
            className={classes.code}
            language='markdown'
            withExpandButton
            withCopyButton={false}
            maxCollapsedHeight={maxCollapsedHeight}
            defaultExpanded={defaultExpanded}
        />
    ) : null;
}